const modal = require('modal');
const calculatePlanUpgradePrice = require('calculatePlanUpgradePrice');

const seasonPlanSales = (function() {
  const $carousel = $('.sp-sales-carousel .flickity-carousel-outer');
  let planString;


  const featureRowAnimation = function() {
    const controller = new ScrollMagic.Controller();

    $('.feature-row').each(function() {
      if ($(this).find('.parallax-bg').length) {
        const bg = this.querySelector('.parallax-bg');

        const sceneOptions = {
          triggerElement: this,
          triggerHook: 0.5,
          duration: '100%',
        };

        new ScrollMagic.Scene(sceneOptions)
        .setClassToggle(this, 'animate-in')
        .addTo(controller);

        if ($(this).hasClass('right')) {
          new ScrollMagic.Scene(sceneOptions)
          .setTween(bg, { x: 150, rotation: -5 })
          .addTo(controller);
        } else {
          new ScrollMagic.Scene(sceneOptions)
          .setTween(bg, { x: -150, rotation: 5 })
          .addTo(controller);
        }
      }
    });
  };


  const buildCarousel = function() {
    $carousel.flickity({
      wrapAround: true,
      autoPlay: 3500,
      pauseAutoPlayOnHover: false,
      pageDots: false,
      prevNextButtons: false,
      selectedAttraction: 0.015,
      friction: 0.25,
    });
  };


  const learnMoreCTA = function() {
    $('.learn-more-cta').on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: $('#learn-more').offset().top,
      }, 1000);
    });
  };


  const dropdownCTA = function() {
    let defaultText = '';

    $('.dropdown-cta').on('click', function(e) {
      e.preventDefault();
      $(this).blur().parent().find('.more-info').slideToggle(300);

      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).text(defaultText);
      } else {
        defaultText = $(this).text();
        $(this).addClass('active');
        $(this).text('Convinced? Hide');
      }
    });
  };


  const getUserAccess = function() {
    getLoggedInUserService(setVariables);
  };


  const setVariables = function(res) {
    planString = res.data.plan_string;
    currentPlanFrequency = res.data.plan_frequency;
    currency = res.data.stripe_currency;
  };


  const getStartedCTA = function() {
    $('.get-started-cta').on('click', function(e) {
      const userAccess = $('.season-plan-sales-page').attr('data-user-access');
      if (userAccess === 'coach_club' || userAccess === 'coach_team' || userAccess === 'premium' || userAccess === 'enterprise') {
        // Go through to create season plan
      } else {
        e.preventDefault();

        const serverPlanVersion = $('.season-plan-sales-page').attr('data-server-plan-version');
        let serverPlanString = '';
        if (serverPlanVersion === 'v1') {
          serverPlanString = '<strong>Team</strong> and <strong>Club</strong>';
        } else {
          serverPlanString = '<strong>Premium</strong> and <strong>Enterprise</strong>';
        }

        // If user is logged in but isn't a Team or Club user
        if (userAccess) {
          $(window).modal({
            title: 'Hold on a minute...',
            content: ` \
            <p>Season Plans are currently only available for ${serverPlanString} users.<br/> \
            You currently have <strong>${planString}</strong> access and need to upgrade to create a Season Plan.</p> \
            <a href="/account/plan" class="btn btn-green"> \
              Upgrade to a compatible account\
            </a> \
            `,
            confirmText: false,
          });
          // If the user isn't logged in or signed up
        } else {
          $(window).modal({
            title: 'Hold on a minute...',
            content: "<p>You need to login before creating a Season Plan. Don't have an account? Not to worry, simply click the link below and sign up today.</p>",
            confirmText: 'Login/Sign up',
            complete() {
              window.location.href = '/login?returnPath=/season-plans';
            },
          });
        }
      }
    });
  };


  const init = function() {
    if ($('.season-plan-sales-page').length) {
      featureRowAnimation();
      buildCarousel();
      learnMoreCTA();
      dropdownCTA();
      getUserAccess();
      getStartedCTA();
    }
  };

  return {
    init,
  };
}());

seasonPlanSales.init();



// WEBPACK FOOTER //
// ./library/js/modules/season-plan-sales.js